import React from 'react';

import Alert from 'react-bootstrap/Alert';

class TextAlert extends React.Component {
    constructor(props) {
	super(props);
	
	this.state = {
	    timeout: null
	};

	this.hide = this.hide.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
	if (this.props.show && !prevProps.show) {
	    const timeout = setTimeout(this.hide, 5000);
	    this.setState({timeout: timeout});
	}
    }
    
    hide() {
	clearTimeout(this.state.timeout);
	this.props.onHide();
    }
    
    render() {
	if (this.props.show) {
	    return (
		<>
		    <br />
		    <Alert variant={this.props.variant} onClose={this.props.onHide} dismissible>
			{this.props.text}
		    </Alert>
		</>
	    );
	}
    }
}

export default TextAlert;
